import { CmsApiBlock } from 'modules/cms/api/types/CmsApiBlock';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import {
  getContentFirstRealBlockIndex,
  getContentOffsetAnchors,
  getContentWithBanner,
  getPrevRealBlock,
} from 'modules/cms/helpers';

import { CmsMappedBlock } from './CmsMappedBlock';
import { mapCmsBlock } from './mapCmsBlock';

type Props = {
  content: CmsApiPage;
};

export function mapCmsBlocksForBody({
  content,
}: Props): CmsMappedBlock<CmsApiBlock>[] {
  const firstRealBlockIndex = getContentFirstRealBlockIndex({ content });
  const offsetAnchors = getContentOffsetAnchors({ content });
  const withBanner = getContentWithBanner({ content });

  return content.contentBlocks
    .map((block, index) => {
      const prevBlock = getPrevRealBlock(content.contentBlocks, index);

      return mapCmsBlock({
        content,
        isBody: true,
        index,
        block,
        isPageHeader: !withBanner && firstRealBlockIndex === index,
        anchor:
          index > 0 && prevBlock && prevBlock.type === 'ANCHOR'
            ? prevBlock
            : undefined,
        offsetAnchors,
      });
    })
    .filter((mappedBlock) => mappedBlock.type !== 'ANCHOR');
}
